import axios, { InternalAxiosRequestConfig } from 'axios'

import { CheckOtpResponseDTO } from '../api/auth/Auth.dto'
import { REFRESH_TOKEN_URL } from '../api/endpoints'
import { routePaths } from '../routes/urls'
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../utils/consts'
import {
  clearCredentialCookies,
  getRefreshTokenFromCookie,
  removeCookie,
  setAccessTokenCookie,
  setRefreshTokenCookie,
} from '../utils/cookieManager'
import { clearCredentialsFromLS } from '../utils/localStorageManager'
import { getPersistentUserToken } from './userAuthTool'

const BASE_URL = import.meta.env.VITE_API_GW_URL

if (!BASE_URL) throw new Error(`BASE_URL must be set`)

// const providerAxios = axios.create({
//   baseURL: BASE_URL,
//   timeout: 100000,
//   withCredentials: true,
// })

const onRequestFulfilled: (value: any) => any | Promise<any> = (
  config: InternalAxiosRequestConfig,
) => {
  const token = getPersistentUserToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else if (typeof config.headers.Authorization === 'string') {
    delete config.headers.Authorization
  }
  return config
}

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 100_000

axios.interceptors.request.use(onRequestFulfilled)

axios.interceptors.response.use(undefined, async (error) => {
  const {
    config,
    response: { status },
  } = error
  switch (config.url) {
    case REFRESH_TOKEN_URL:
      if (status !== 200) {
        removeCookie(ACCESS_TOKEN)
        removeCookie(REFRESH_TOKEN)
        clearCredentialCookies()
        clearCredentialsFromLS()
        window.location.pathname = routePaths.AUTH.url
      }
      break
    default:
      if (status === 401) {
        // clearCredentialCookies()
        // clearCredentialsFromLS()
        try {
          const response = await axios.post<CheckOtpResponseDTO>(REFRESH_TOKEN_URL, {
            refresh: getRefreshTokenFromCookie(),
          })
          if (response && response.status === 200) {
            setAccessTokenCookie(response.data.access)
            setRefreshTokenCookie(response.data.refresh)
            return axios({
              ...config,
              headers: { Authorization: `Bearer ${response.data.access}` },
            })
          }
        } catch (err) {
          return err
        }
      } else {
        return error
      }
      break
  }
})

export const providerAxios = axios
